"use client";

import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function Success() {
  const categories = ["All", "Brand Strategy", "Content Growth", "Digital Presence", "Consulting"];
  const projects = [{
    id: 1,
    name: "Modern Minimalist Identity",
    category: "Brand Strategy",
    location: "Seoul, Korea",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/brand_identity_minimal.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/brand_identity_minimal.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/brand_identity_minimal.png-wvc-sizes",
    aspect: "aspect-[4/5]"
  }, {
    id: 2,
    name: "Editorial Content Series",
    category: "Content Growth",
    location: "Global Digital",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/editorial_content_series.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/editorial_content_series.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/editorial_content_series.webp-wvc-sizes",
    aspect: "aspect-square"
  }, {
    id: 3,
    name: "High-End Fashion Launch",
    category: "Digital Presence",
    location: "Paris, France",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/fashion_launch_digital.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/fashion_launch_digital.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/fashion_launch_digital.png-wvc-sizes",
    aspect: "aspect-[16/9]"
  }, {
    id: 4,
    name: "Consulting Strategy Shift",
    category: "Consulting",
    location: "New York, USA",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/consulting_strategy_shift.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/consulting_strategy_shift.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/consulting_strategy_shift.webp-wvc-sizes",
    aspect: "aspect-square"
  }, {
    id: 5,
    name: "Artistic Brand Refresh",
    category: "Brand Strategy",
    location: "Tokyo, Japan",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/artistic_brand_refresh.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/artistic_brand_refresh.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/artistic_brand_refresh.png-wvc-sizes",
    aspect: "aspect-[4/5]"
  }, {
    id: 6,
    name: "Growth Marketing Audit",
    category: "Content Growth",
    location: "London, UK",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/growth_marketing_audit.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/growth_marketing_audit.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/growth_marketing_audit.webp-wvc-sizes",
    aspect: "aspect-[16/9]"
  }];
  const [activeFilter, setActiveFilter] = useState<string>("All");
  const [cursorPos, setCursorPos] = useState({
    x: 0,
    y: 0
  });
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  const filtered = activeFilter === "All" ? projects : projects.filter(p => p.category === activeFilter);
  return <section data-section-id="895" id="quantifiable-success" className="bg-background text-foreground pt-24 pb-24 relative">
      <div className="container mx-auto px-6 lg:px-12 max-w-[1440px]">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 lg:mb-24">
          <div className="lg:col-span-7">
            <p className="font-default text-xs uppercase tracking-[0.25em] text-primary mb-6">
              [ Results ]
            </p>
            <h2 className="font-default font-medium text-foreground leading-[0.9] tracking-[0.15em]" style={{
            fontSize: "clamp(3rem, 8vw, 7.5rem)"
          }}>
              Impact that speaks for itself.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex flex-col justify-end">
            <p className="text-foreground text-lg leading-relaxed mb-6">
              Marketing is not about noise. It is about the quiet, deliberate alignment of your vision with the people who need it most.
            </p>
            <p className="font-default italic text-sm text-muted-foreground">
              — hover to explore the work
            </p>
          </div>
        </div>

        {}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 mb-12 pb-6 border-b border-border">
          <div className="flex flex-wrap gap-2">
            {categories.map((cat, i) => {
            const isActive = activeFilter === cat;
            return <Button key={cat} data-index={i} onClick={() => setActiveFilter(cat)} variant="outline" size="sm" className={isActive ? "rounded-lg border-primary bg-primary text-white font-default text-xs uppercase tracking-[0.25em] px-8 h-12" : "rounded-lg border-border bg-transparent text-foreground hover:bg-accent hover:text-foreground font-default text-xs uppercase tracking-[0.25em] px-8 h-12"}>
                  {cat}
                </Button>;
          })}
          </div>
          <div className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground whitespace-nowrap">
            {filtered.length.toString().padStart(2, "0")} Projects
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" onMouseMove={e => {
        const rect = e.currentTarget.getBoundingClientRect();
        setCursorPos({
          x: e.clientX - rect.left,
          y: e.clientY - rect.top
        });
      }}>
          {filtered.map((project, i) => <div key={project.id} data-index={i} className="group relative overflow-hidden cursor-none" onMouseEnter={() => setHoveredId(project.id)} onMouseLeave={() => setHoveredId(null)}>
              <div className={`relative overflow-hidden ${project.aspect}`}>
                <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.02]" />
                {}
                <div className="absolute inset-0 bg-primary/90 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-between p-8">
                  <div>
                    <p className="font-default text-xs uppercase tracking-[0.25em] text-white/70 mb-3">
                      {project.category}
                    </p>
                    <h3 className="font-default font-medium text-white text-3xl leading-tight mb-2">
                      {project.name}
                    </h3>
                    <p className="text-white/80 text-sm">
                      {project.location}
                    </p>
                  </div>
                  <div className="flex items-end justify-between">
                    <div className="font-default text-xs uppercase tracking-[0.25em] text-white/60">
                      MD-{project.id.toString().padStart(2, "0")}
                    </div>
                    <div className="flex items-center gap-2 font-default text-xs uppercase tracking-[0.25em] text-white">
                      <Plus className="size-4" strokeWidth={1.5} />
                      View
                    </div>
                  </div>
                </div>
              </div>
            </div>)}

          {}
          {hoveredId !== null && <div className="pointer-events-none absolute z-10 hidden lg:flex items-center justify-center size-20 bg-primary text-white font-default text-xs uppercase tracking-[0.25em]" style={{
          left: cursorPos.x,
          top: cursorPos.y,
          transform: "translate(-50%, -50%)",
          borderRadius: "0px"
        }}>
              View
            </div>}
        </div>

        {}
        <div className="flex justify-center mt-24">
          <Button variant="outline" size="lg" className="rounded-lg border-primary bg-primary text-white hover:bg-primary/90 font-default text-xs uppercase tracking-[0.25em] px-12 h-16">
            View All Work
            <Plus className="size-4 ml-2" strokeWidth={1.5} />
          </Button>
        </div>
      </div>
    </section>;
}